'use strict';

var resultsList = function () {
	var _init = function _init() {
		if (typeof resultados !== 'undefined' && resultados !== '') {
			_buildList(resultados.listado);
			_buildBreadCrumbs(resultados.breadcrumbs);
		} else {
			console.error('lista de resultados no definida o vacía');
		}
	};

	var _buildBreadCrumbs = function _buildBreadCrumbs(bc) {
		bcSize = utils.getObjectSize(bc) / 2;
		bcLastEmpty = function bcLastEmpty() {
			return bc['nivel' + bcSize].trim() !== '';
		};
		bcIterator = bcLastEmpty() ? bcSize : bcSize - 1;

		$('.js-bc-0').attr('href', bc.link0);
		if (bcIterator > 1) {
			for (var i = 1; i < bcIterator; i++) {
				$link = $('#js-bc-link-tpt').clone().removeAttr('id').removeClass('hidden');
				$link.text(bc['nivel' + i].toUpperCase()).attr('href', bc['link' + i]);
				$('.js-bc-links').append($link);
			}
		}
		$('.js-bc-last').text(bc['nivel' + bcIterator].toUpperCase());
	};

	var _buildList = function _buildList(list) {
		var $container = $('.js-listado');
		var $tptElem = $('#js-accesorio-template');

		$container.empty();

		for (var i = 0; i < list.length; i++) {
			var item = list[i];
			var $domNode = $tptElem.clone().removeAttr('id');

			$domNode.find('.js-imagen-accesorio').attr({
				'src': item.imagen,
				'alt': item.nombre
			});

			$domNode.find('.js-descripcion-accesorio').text(item.nombre);
			$domNode.find('.js-pvp').text(parseFloat(item.pvp).toLocaleString('es-ES'));
			$domNode.find('.js-pvc').text(parseFloat(item.pvc).toLocaleString('es-ES'));
			$domNode.find('.js-ref').text(item.ref);
			$domNode.find('.js-link').attr('href', item.link);

			// Comprobamos si está en el carrito para marcar el checkbox
			var existsInCartList = cartList.matchRefAndMoi(item.ref, modelmoi);

			if (existsInCartList.length > 0) {
				$domNode.find('.js-add-cartlist').prop('checked', true);
			}
			// Añadimos el listener para cambiar el carrito
			$domNode.find('.js-add-cartlist').attr('data-ref', item.ref).on('change', function () {
				cartList.checkboxListener($(this));
			});

			$container.append($domNode);
		}
	};

	return {
		init: _init
	};
}();